import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { BsDownload } from 'react-icons/bs';
import Carousel, { Modal, ModalGateway } from 'react-images';
import * as defaults from 'react-images/lib/styles';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { hooks } from 'botframework-webchat-component';
import { mobileAndTabletcheck } from '../utils/mobileAndTabletCheck';
import { DirectLineAttachment } from 'botframework-webchat-core';


const { useActivities, useDisabled, useSuggestedActions, useUserID, useStyleSet, useDirection, useLocalizer } = hooks;


export type DruidImageViewHandle = {
    setShow: (show: boolean) => void
    setCurrentPictureIndex: (index: number) => void
  }
export const DruidImagesViewer = forwardRef<DruidImageViewHandle, {}>((props, forwardedRef) => {
  
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [show, setShow] = useState(false);
    const [currentPictureIndex, setCurrentPictureIndex] = useState(0);
    const [activities] = useActivities();
    const images = activities.filter(act => act.type === 'message' && act.attachments?.length)
                              .map(att => att.type === 'message' && att.attachments?.filter(fAtt => /^image\//u.test(fAtt.contentType)))
                              .filter(act => !!act)
                              .flat() as DirectLineAttachment[];
  
    useImperativeHandle(forwardedRef, () => {
      return {
        setShow,
        setCurrentPictureIndex
      }
    }, [setShow]);
  
    const notVisibleProps = { showNavigationOnTouchDevice: true };
    return (
      ReactDOM.createPortal(
        <div className="druid-wrapper-ignore" ref={wrapperRef}>
        <ModalGateway>
          {show ? (
            <Modal onClose={() => setShow(false)} styles={defaults.defaultModalStyles} closeOnBackdropClick={mobileAndTabletcheck()}   {...notVisibleProps} >
              <Carousel hideControlsWhenIdle={false} 
              key={currentPictureIndex}
              currentIndex={currentPictureIndex}
              {...notVisibleProps}
              styles={
                 {
                     container: (base, state) => ({...defaults.defaultCarouselStyles.container(base, state), ...{ width: '100vw'}}),
                    //  navigation: (base, state) => ({...defaults.defaultCarouselStyles.navigation(base, state), ...{ }}),
                    //  defaults.defaultCarouselStyles.navigationPrev(base, state)
                     navigationPrev: (base, state) => ({...defaults.defaultCarouselStyles.navigationPrev(state), ...{ background: 'gray'}}),
                     navigationNext: (base, state) => ({...defaults.defaultCarouselStyles.navigationNext(state), ...{ background: 'gray'}}),
                     view: (base, state) => ({...defaults.defaultCarouselStyles.view(state), ...{ '& img': { maxHeight: '80vh !important', maxWidth: '80% !important'}}}),
                 } 
                //  {...mergedCarouselStyles}
              }
              
              components={{
                HeaderFullscreen: (props) => (
                    <a 
                    key={currentPictureIndex}
                    style={{ // copied from close button's css
                        color: 'rgba(255, 255, 255, 0.75)',
                        height: 44,
                        width: 44,
                        display: 'inline-flex',
                        outline: 0,
                        border: 0
                    }} 
                    href={ images[currentPictureIndex]?.contentUrl ||  images[currentPictureIndex]?.thumbnailUrl} download={images[currentPictureIndex]?.name} >
                        <BsDownload size={30}/>
                    </a>)
              }}
              trackProps={{
                onViewChange: (newIndex) => {  setCurrentPictureIndex(newIndex)}
              }}
              views={ images.map(img => ({
                  // fullscreen: img.contentUrl || img.thumbnailUrl,
                  // thumbnail: img.thumbnailUrl,
                  source: img.thumbnailUrl || img.contentUrl || "",
            }))} />
            </Modal>
          ) : null}
          {/* <Modal.Header closeButton>
            <Modal.Title>Modal</Modal.Title>
          </Modal.Header>
          <Modal.Body> */}
        {/* {!!images?.length && 
        <ImageGallery items={
            images.map(img => ({
                  original: img.contentUrl || img.thumbnailUrl,
                  thumbnail: img.thumbnailUrl
            }))
          }
          onClickNext={() => {}}  
        />} */}
  
      {/* </Modal.Body> */}
     
        </ModalGateway>
        </div>
        , document.body)
    )
  });
  